import {SizeSelection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useMemo} from 'react';

export const useIsSingleSizeSelection = (
  sizeSelection: SizeSelection['type'],
) => {
  return useMemo(() => {
    switch (sizeSelection?.$case) {
      case 'sizeRuns': {
        return sizeSelection.sizeRuns.sizeRuns[0]?.sizes.length === 1;
      }
      case 'sizes': {
        return sizeSelection?.sizes.sizes.length === 1;
      }
      case 'inlineSelection': {
        return sizeSelection?.inlineSelection.sizes.length === 1;
      }
      case 'oneSize': {
        return true;
      }
      case 'groupedSizes': {
        return sizeSelection?.groupedSizes.groups.every(groupedSize => {
          if (groupedSize.content?.$case === 'sizeRuns') {
            return groupedSize.content.sizeRuns.sizeRuns[0]?.sizes.length === 1;
          }

          return groupedSize.content?.sizes.sizes.length === 1;
        });
      }
      default:
        return false;
    }
  }, [sizeSelection]);
};
